import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 53 100" xmlns="http://www.w3.org/2000/svg" {...this.props}><path d="M5.16 99.14l-3.01-3.01L48.6 50.11 2.15 4.3l3.01-3.01 49.46 48.82" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/arrow-right.svg